// extracted by mini-css-extract-plugin
export default {"pulse":"components-hotel-net-revenue-skeleton-module__pulse","skeleton-pulse":"components-hotel-net-revenue-skeleton-module__skeleton-pulse"};